import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobAttachmentActions'
import * as api from '../../api/job/attachments'

function* attachmentsRefresh(action) {
  try {
    const payload = yield call(api.getJobAttachments, action.jobId)
    yield put({ type: constants.ATTACHMENTS_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ATTACHMENTS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchAttachments() {
  yield takeLatest(constants.ATTACHMENTS_REFRESH.ACTION, attachmentsRefresh)
}

function* sagaCreateAttachment(action) {
  try {
    const payload = {
      job_id: action.jobId,
      content: action.content,
      file: action.file,
      filename: action.filename,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }

    yield call(api.createAttachment, payload)
    yield put({ type: constants.ATTACHMENT_CREATE.SUCCESS, payload })
    yield call(attachmentsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ATTACHMENT_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateAttachment() {
  yield takeLatest(constants.ATTACHMENT_CREATE.ACTION, sagaCreateAttachment)
}

function* sagaUpdateAttachment(action) {
  try {
    const payload = {
      description: action.description,
      attachment_id: action.attachmentId,
      updated_by_id: action.userId
    }
    yield call(api.updateAttachment, payload)
    yield put({ type: constants.ATTACHMENT_UPDATE.SUCCESS, payload })
    yield call(attachmentsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ATTACHMENT_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAttachment() {
  yield takeLatest(constants.ATTACHMENT_UPDATE.ACTION, sagaUpdateAttachment)
}

function* sagaDeleteAttachment(action) {
  try {
    const payload = {
      attachment_id: action.attachmentId
    }
    yield call(api.deleteAttachment, payload)
    yield put({ type: constants.ATTACHMENT_DELETE.SUCCESS, payload })
    yield call(attachmentsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ATTACHMENT_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAttachment() {
  yield takeLatest(constants.ATTACHMENT_DELETE.ACTION, sagaDeleteAttachment)
}

function* getAttachments(action) {
  try {
    const payload = yield call(api.getJobAttachments, {
      job_id: action.jobId,
      attachment_id: action.attachmentId,
      type: 'job'
    })
    yield put({ type: constants.GET_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAttachments() {
  yield takeLatest(constants.GET_ATTACHMENTS.ACTION, getAttachments)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchAttachments),

    fork(watchCreateAttachment),
    fork(watchUpdateAttachment),
    fork(watchDeleteAttachment),

    fork(watchGetAttachments)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobAttachmentSaga.js